import { useContext } from "react";
import { Form, Formik } from "formik";
import InputFormik from "../../../../common/components/form/InputFormik";
import ButtonWithLoader from "../../../../common/components/ui/loading/ButtonLoading";
import * as Yup from 'yup';
import { maskOfCpfOrCnpj, maskPhone } from "../../../../common/helpers/mask.helpers";
import { AuthContext } from '../../../../common/components/auth/authContext/AuthContext';
import TextareaFormik from "../../../renters/components/forms/TextareaFormik";

const validationSchema = Yup.object().shape({
  companyName: Yup.string().required('Razão Social obrigatória'),
  tradingName: Yup.string().required('Nome obrigatório'),
  supplierEmail: Yup.string().required('E-mail obrigatório'),
  cnpj: Yup.string().required('CNPJ obrigatório'),
  operationalContact: Yup.object().shape({
    name: Yup.string().required('Nome do contato operacional é obrigatório.'),
    phone: Yup.string().required('WhatsApp é obrigatório.'),
  }),
  workContact: Yup.object().shape({
    name: Yup.string().required('Nome do contato operacional é obrigatório.'),
    phone: Yup.string().required('WhatsApp é obrigatório.'),
  }),
})

type PropsFormCreateSupplier = {
  onSubmit: (values: { tradingName: string }) => void;
}

function FormCreateSupplier(props: PropsFormCreateSupplier) {
  const authCtx = useContext(AuthContext);
  const userEmail = authCtx.auth?.user?.email;

  const initialValues = {
    tradingName: '',
    companyName: '',
    cnpj: '',
    workContact: {
      name: '',
      phone: '',
    },
  }

  const handleSubmit = async (values, { setSubmitting }) => {
    setSubmitting(true);
    const dataToSave = {
      ...values,
      observations: {
        text: values.observations,
        date: new Date().toISOString(),
        author: userEmail || ""
      }
    }
    await props.onSubmit(dataToSave);
    setSubmitting(false);
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting, handleSubmit }) => {
        return (
          <Form className="grid grid-cols-2 gap-2">
            <InputFormik
              label='Razão Social:'
              name='companyName'
              className='col-span-2'
              required={true}
            />
            <InputFormik
              label='Nome fantasia:'
              name='tradingName'
              className='col-span-2'
              required={true}
            />
            <InputFormik
              label='E-mail:'
              name='supplierEmail'
              className='col-span-1'
              required={true}
            />
            <InputFormik
              label='CNPJ ou CPF:'
              name='cnpj'
              className='col-span-1'
              required={true}
              mask={maskOfCpfOrCnpj}
            />
            <InputFormik
              label='Nome do contato operacional:'
              name='operationalContact.name'
              className='col-span-1'
              required={true}
            />
            <InputFormik
              label='Telefone operacional:'
              name='operationalContact.phone'
              className='col-span-1'
              required={true}
              mask={maskPhone}
            />
            <InputFormik
              label='Nome do contato comercial:'
              name='workContact.name'
              className='col-span-1'
              required={true}
            />
            <InputFormik
              label='Telefone comercial:'
              name='workContact.phone'
              className='col-span-1'
              required={true}
              mask={maskPhone}
            />
            <section className="col-span-2">
              <div className="dark:text-black bg-gray/40 rounded my-4 p-3">
                <h2 className="font-semibold text-2xl mb-4">Observações</h2>
                <div>
                  <TextareaFormik
                    label="Observação:"
                    name={`observations`}
                    className="min-h-64 w-full rounded shadow-md focus:border-white"
                  />
                </div>
              </div>
            </section>
            <div className="flex justify-end col-span-2">
              <ButtonWithLoader isLoading={isSubmitting} onClick={handleSubmit}> Enviar </ButtonWithLoader>
            </div>
          </Form>
        )
      }}
    </Formik>
  )
}

export default FormCreateSupplier;